const baseReportUrl = "Report"



  const endpoints = {
    getSummaryReport:`${baseReportUrl}/SummaryReport`,
    
 
  };
  
  export default endpoints;
  